import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "amfe-flexible";
import "amfe-flexible/index.js";
import globalComponent from "@/assets/js/components";
import "@/assets/styles/reset.styl";

createApp(App)
  .use(router)
  .use(store)
  .use(globalComponent)
  .mount("#app");
